import * as React from "react"

const ArrowIcon = (props) => (
  
<svg width={props.width} height={props.height} className={props.className} viewBox="0 0 21 16" xmlns="http://www.w3.org/2000/svg" {...props}>
<title>{"Atoms/UI/Icons/Arrow/Right/large"}</title>
<g
  stroke={props.stroke}
  strokeWidth={2}
  fill="none"
  fillRule="evenodd"
  strokeLinecap="round"
>
  <path strokeLinejoin="round" d="m12.111 0 7.937 8-7.937 8" />
  <path d="M20 8H1" />
</g>
</svg>
)

export default ArrowIcon
